'use client';

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { DataTable } from '@/components/data-table/data-table';
import { useDataTable } from '@/hooks/use-data-table';
import { useOrgNavigate } from '@/hooks/use-app-navigate';
import { Dispute } from '@/lib/api/disputes';

import { getDisputesTableColumns } from './disputes-table-columns';

interface DisputesTableProps {
  disputes: Dispute[];
  isLoading: boolean;
}

export function DisputesTable({ disputes, isLoading }: DisputesTableProps) {
  const { t } = useTranslation('disputes');
  const navigate = useNavigate();
  const { orgRoutes } = useOrgNavigate();

  const columns = getDisputesTableColumns({ t });

  const { table } = useDataTable({
    data: disputes,
    columns,
    total: disputes.length,
    config: { clientMode: true, defaultSorting: [{ id: 'openedAt', desc: true }] },
    onTableStateChange: () => {},
    getRowId: (row) => row.id,
  });

  const handleRowClick = React.useCallback(
    (dispute: Dispute) => {
      navigate(orgRoutes.DISPUTE_DETAILS(dispute.id));
    },
    [navigate, orgRoutes],
  );

  return (
    <DataTable
      table={table}
      isLoading={isLoading}
      showFilters={false}
      showToolbar={false}
      showPagination
      onRowClick={handleRowClick}
    />
  );
}
